import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API, pacienteAuthHeaders } from '../../services/pacienteConfig';
import { PacienteTabNavigation, pacienteLogout } from '../../components/paciente/PacientePortalNav';
import './PacienteDashboard.css';

const PacienteDashboard = () => {
  const [paciente, setPaciente] = useState(null);
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    pacienteLogout(navigate);
  }, [navigate]);

  useEffect(() => {
    const mainSidebar = document.querySelector('.sidebar');
    if (mainSidebar) mainSidebar.style.display = 'none';

    return () => {
      if (mainSidebar) mainSidebar.style.display = '';
    };
  }, []);

  useEffect(() => {
    const fetchPerfil = async () => {
      try {
        const resp = await fetch(`${API}/paciente/perfil`, {
          headers: pacienteAuthHeaders(),
        });
        if (resp.status === 401) {
          handleLogout();
          return;
        }
        const data = await resp.json();
        if (data.success) {
          setPaciente(data.data);
          localStorage.setItem('paciente_user', JSON.stringify(data.data));
        }
      } catch (err) {
        console.error('Error fetching perfil', err);
      }
    };

    const stored = localStorage.getItem('paciente_user');
    if (stored) {
      try {
        setPaciente(JSON.parse(stored));
      } catch (_e) {
        // ignore corrupt localStorage
      }
    }

    fetchPerfil();
  }, [handleLogout]);

  const goTo = (path) => {
    navigate(`/paciente/${path}`);
  };

  return (
    <div className="paciente-dashboard-layout">
      <div className="paciente-content">
        <header className="pd-header">
          <div>
            <span className="pd-eyebrow">Portal del paciente</span>
            <h1>Hola, {paciente?.nombre || 'Paciente'}</h1>
            <p>Gestiona tu historia clinica, turnos y datos personales.</p>
          </div>
        </header>

        <div className="pd-cards-grid">
          <button type="button" className="pd-card" onClick={() => goTo('historia-clinica')}>
            <div className="pd-card-icon">HC</div>
            <div className="pd-card-info">
              <h3>Mi Historia Clinica</h3>
              <p>Completa o actualiza tus datos medicos</p>
            </div>
          </button>

          <button type="button" className="pd-card" onClick={() => goTo('turnos')}>
            <div className="pd-card-icon">TU</div>
            <div className="pd-card-info">
              <h3>Mis Turnos</h3>
              <p>Consulta tus proximos turnos</p>
            </div>
          </button>

          <button type="button" className="pd-card" onClick={() => goTo('datos')}>
            <div className="pd-card-icon">PF</div>
            <div className="pd-card-info">
              <h3>Mis Datos</h3>
              <p>Actualiza tu informacion personal</p>
            </div>
          </button>
        </div>
      </div>

      <PacienteTabNavigation activeTab="inicio" />
    </div>
  );
};

export default PacienteDashboard;
